/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhonePackSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-PACK-001
 * PURPOSE: QA Pack / Inspection / NCR generate, re-queue, download.
 */
import { MobileSheet } from '@quotech/ui'
import type { QaApi } from '../../../../qa/qaApi'
import { JobQaPackPanel } from '../../../JobQaPackPanel'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhonePackSheet({
  open,
  onClose,
  inspectionId,
  api,
}: {
  open: boolean
  onClose: () => void
  inspectionId: string
  api: QaApi
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Pack" size="full">
      <div data-qa-phone-control={QA_PHONE_CONTROLS.pack} className="p-3">
        <JobQaPackPanel inspectionId={inspectionId} api={api} />
      </div>
    </MobileSheet>
  )
}
